module.exports = __webpack_public_path__ + "static/media/logo-imdb.39a1dc2b.svg";